// `apps/web` Web Vitals reporter — Web Wave 9 (US-246).
//
// Subscribes to LCP, CLS, INP, FCP, TTFB and forwards each metric to
// `analytics.webVitals(...)`. Each metric only fires once per page load (or
// on visibility-change for INP/CLS), so the volume is bounded.
//
// The function is a single side-effect entry; call it exactly once after
// `bootAnalytics()` in `main.tsx`.

import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';

import { analytics } from '@/lib/analytics';

function report(metric: Metric): void {
  analytics.webVitals({
    name: metric.name,
    value: Math.round(metric.value),
    id: metric.id,
    route: typeof window !== 'undefined' ? window.location.pathname : undefined,
  });
}

export function reportWebVitals(): void {
  if (typeof window === 'undefined') return;
  onLCP(report);
  onCLS(report);
  onINP(report);
  onFCP(report);
  onTTFB(report);
}
